<template>
  <v-container fluid v-if="user != null">
    <v-layout row wrap>
      <v-flex
        pa-2
      >
        <v-card>
          <v-toolbar>
            <v-toolbar-title>{{user.name}}</v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Email adress</v-list-tile-title>
                <v-list-tile-sub-title v-html="user.email"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Roles</v-list-tile-title>
                <v-list-tile-sub-title v-for="(role, j) in user.roles" :key="j">
                  <span>{{ role }}</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="remove(user)">
              Remove
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-btn
      bottom
      fab
      fixed
      right
      @click="goToEdit"
    >
      <v-icon>create</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: 'UserShowView',
  computed: {
    user() {
      return this.$store.getters.getUser(this.$route.params.id);
    },
  },
  methods: {
    goToEdit() {
      this.$router.push({
        name: 'Edit User',
        params: { id: this.$route.params.id },
      });
    },
    remove(user) {
      this.$store.commit('deleteUser', user);
      this.$router.push({ name: 'Users' });
    },
  },
};
</script>
